import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchProductsRequest from "./requests/searchProductsRequest";
import getProductBestPrice from "./requests/getProductBestPrice";
import deleteProductRequest from "./requests/deleteProductRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const productEndpoints: RequestDefinitionData[] = [
    searchProductsRequest,
    getProductBestPrice,
    deleteProductRequest,
];

export const productHeader = {
    title: 'Product',
    description: 'This is an object representing a Fishbowl product.',
    linkName: 'Product',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Product',
    endpoints: productEndpoints,
};

export const jsonObject: Json = {
    title: 'THE PRODUCT OBJECT',
    json: {}
};

export const productAttributes: Attribute[] = [];
